import { jsxs, jsx } from 'react/jsx-runtime';
import { NotificationCounter, Cart, Menu, MenuItem } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';
import { M as MemberLink, a as MEMBER_LINK_VARIANT_DESKTOP } from './component-DV6bFT4K.js';
import { S as SgcmLogo } from './component-D5qJ4zZ9.js';
import { S as SearchInput } from './component-CNkB69_x.js';
import { s as styleInject } from './style-inject.es-Bff-fD1R.js';

const HEADER_LINK_TYPE_SINGLE = 'single';
const HEADER_LINK_TYPE_MULTIPLE = 'multiple';
const LINK_KEY_NEW_CARS = 'newCars';
const LINK_KEY_USED_CARS = 'usedCars';
const LINK_KEY_ELECTRIC_CARS = 'electricCars';
const LINK_KEY_HYBRID_CARS = 'hybridCars';
const LINK_KEY_CAR_LOAN = 'carLoan';
const LINK_KEY_RENTAL_CARS = 'rentalCars';
const LINK_KEY_SELL_CARS = 'sellCars';
const LINK_KEY_DIRECTORY = 'directory';
const LINK_KEY_E_SHOP = 'eShop';
const LINK_KEY_INSURANCE = 'insurance';
const LINK_KEY_ARTICLES = 'articles';
const LINK_KEY_MORE = 'more';
const LINK_KEY_FORUM = 'forum';
const LINK_KEY_RESOURCES = 'resources';
const HEADER_SHOPPING_CART_ICON_SIZE = 23;

const headerLinkConfigList = [
    {
        type: HEADER_LINK_TYPE_SINGLE,
        key: LINK_KEY_NEW_CARS,
        text: 'New',
        href: 'https://www.sgcarmart.com/new_cars/index.php',
    },
    {
        type: HEADER_LINK_TYPE_SINGLE,
        key: LINK_KEY_USED_CARS,
        text: 'Used',
        href: 'https://www.sgcarmart.com/used-cars',
    },
    {
        type: HEADER_LINK_TYPE_SINGLE,
        key: LINK_KEY_ELECTRIC_CARS,
        text: 'Electric',
        href: 'https://www.sgcarmart.com/electric-vehicle',
    },
    {
        type: HEADER_LINK_TYPE_SINGLE,
        key: LINK_KEY_HYBRID_CARS,
        text: 'Hybrid',
        href: 'https://www.sgcarmart.com/hybrid-vehicle',
    },
    {
        type: HEADER_LINK_TYPE_SINGLE,
        key: LINK_KEY_CAR_LOAN,
        text: 'Loan',
        href: 'https://www.sgcarmart.com/car-loan',
    },
    {
        type: HEADER_LINK_TYPE_SINGLE,
        key: LINK_KEY_RENTAL_CARS,
        text: 'Rent',
        href: 'https://www.sgcarmart.com/car_rental/index.php',
    },
    {
        type: HEADER_LINK_TYPE_MULTIPLE,
        key: LINK_KEY_SELL_CARS,
        text: 'Sell',
        href: 'https://www.sgcarmart.com/sell-car',
        menuItemList: [
            {
                key: 'sellByYourself',
                text: 'Sell By Yourself',
                href: 'https://www.sgcarmart.com/sell-car/post-an-ad',
            },
            {
                key: 'sellByBidding',
                text: 'Sell By Bidding',
                href: 'https://www.sgcarmart.com/quotz/sell_by_bid.php?type=sbbid',
            },
            {
                key: 'sellByConsignment',
                text: 'Sell By Consignment',
                href: 'https://www.sgcarmart.com/tools_tips/consignment.php',
            },
        ],
    },
    {
        type: HEADER_LINK_TYPE_MULTIPLE,
        key: LINK_KEY_DIRECTORY,
        text: 'Directory',
        href: 'https://www.sgcarmart.com/directory/index.php',
        menuItemList: [
            {
                key: 'workshops',
                text: 'Workshops',
                href: 'https://www.sgcarmart.com/directory/index.php',
            },
            {
                key: 'products',
                text: 'Products',
                href: 'https://www.sgcarmart.com/products/index.php',
            },
        ],
    },
    {
        type: HEADER_LINK_TYPE_SINGLE,
        key: LINK_KEY_E_SHOP,
        text: 'e-Shop',
        href: 'https://www.sgcarmart.com/shop',
    },
    {
        type: HEADER_LINK_TYPE_SINGLE,
        key: LINK_KEY_INSURANCE,
        text: 'Insurance',
        href: 'https://www.sgcarmart.com/car-insurance',
    },
    {
        type: HEADER_LINK_TYPE_MULTIPLE,
        key: LINK_KEY_ARTICLES,
        text: 'Articles',
        href: 'https://www.sgcarmart.com/articles',
        menuItemList: [
            {
                key: 'carReviews',
                text: 'Car Reviews',
                href: 'https://www.sgcarmart.com/articles/car-reviews',
            },
            {
                key: 'carAdvice',
                text: 'Car Advice',
                href: 'https://www.sgcarmart.com/articles/advice',
            },
            {
                key: 'carNews',
                text: 'Car News',
                href: 'https://www.sgcarmart.com/articles/news',
            },
            {
                key: 'CarFeatures',
                text: 'Car Features',
                href: 'https://www.sgcarmart.com/articles/features',
            },
            {
                key: 'carVideos',
                text: 'Car Videos',
                href: 'https://www.sgcarmart.com/articles/videos',
            },
        ],
    },
    {
        type: HEADER_LINK_TYPE_MULTIPLE,
        key: LINK_KEY_MORE,
        text: 'More',
        href: '#',
        menuItemList: [
            {
                key: LINK_KEY_FORUM,
                text: 'Forum',
                href: 'https://www.sgcarmart.com/forum/index.php',
            },
            {
                key: LINK_KEY_RESOURCES,
                text: 'Resources',
                href: 'https://www.sgcarmart.com/resources',
            },
        ],
    },
];

var css_248z = ".SGCM_UIKIT_NEXT_Desktop_containerRoot_yac55_1 {\n  display: grid;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding-top: 18px;\n  background-color: white;\n  gap: 15px 32px;\n  grid-template: \"logo searchBar shoppingCart user\" 44px \"link link link link\" auto/max-content 1fr 23px max-content;\n}\n\n.SGCM_UIKIT_NEXT_Desktop_containerSgcmLogo_yac55_12 {\n  display: flex;\n  grid-area: logo;\n}\n\n.SGCM_UIKIT_NEXT_Desktop_containerShoppingCartIcon_yac55_17 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.SGCM_UIKIT_NEXT_Desktop_containerShoppingCartCount_yac55_23 {\n  top: -2px;\n  right: -4px;\n}\n\n.SGCM_UIKIT_NEXT_Desktop_containerSearchBar_yac55_28 {\n  display: flex;\n  width: 100%;\n  height: 43px;\n  justify-content: flex-end;\n  grid-area: searchBar;\n}\n\n.SGCM_UIKIT_NEXT_Desktop_containerShoppingCart_yac55_17 {\n  grid-area: shoppingCart;\n}\n\n.SGCM_UIKIT_NEXT_Desktop_containerMemberLink_yac55_40 {\n  grid-area: user;\n}\n\n.SGCM_UIKIT_NEXT_Desktop_iconHeader_yac55_44 {\n  color: #5f5f5f;\n}\n\n.SGCM_UIKIT_NEXT_Desktop_listHeaderLink_yac55_48 {\n  display: flex;\n  min-width: 950px;\n  max-width: 1286px;\n  justify-content: space-between;\n  padding: 0;\n  margin: 0;\n  grid-area: link;\n  list-style-type: none;\n}\n\n.SGCM_UIKIT_NEXT_Desktop_menuHeaderLink_yac55_59 {\n  position: absolute;\n  z-index: 1050;\n  left: 50%;\n  display: none;\n  width: unset;\n  min-width: 160px;\n  height: unset;\n  transform: translate(-50%, -8px);\n}\n\n.SGCM_UIKIT_NEXT_Desktop_containerHeaderMultipleLink_yac55_70 {\n  position: relative;\n}\n.SGCM_UIKIT_NEXT_Desktop_containerHeaderMultipleLink_yac55_70:hover > .SGCM_UIKIT_NEXT_Desktop_menuHeaderLink_yac55_59 {\n  display: block;\n}\n\na.SGCM_UIKIT_NEXT_Desktop_linkHeader_yac55_77 {\n  display: inline-block;\n  padding-bottom: 10px;\n  color: #333333;\n  font-size: 1.6rem;\n  font-weight: 500;\n  line-height: 1.375;\n}\na.SGCM_UIKIT_NEXT_Desktop_linkHeader_yac55_77.SGCM_UIKIT_NEXT_Desktop_isActive_yac55_85 {\n  color: #db1a21;\n}\n\n.SGCM_UIKIT_NEXT_Desktop_textHeaderMenuItem_yac55_89 {\n  text-wrap: nowrap;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var styles = {"containerRoot":"SGCM_UIKIT_NEXT_Desktop_containerRoot_yac55_1","containerSgcmLogo":"SGCM_UIKIT_NEXT_Desktop_containerSgcmLogo_yac55_12","containerShoppingCartIcon":"SGCM_UIKIT_NEXT_Desktop_containerShoppingCartIcon_yac55_17","containerShoppingCartCount":"SGCM_UIKIT_NEXT_Desktop_containerShoppingCartCount_yac55_23","containerSearchBar":"SGCM_UIKIT_NEXT_Desktop_containerSearchBar_yac55_28","containerShoppingCart":"SGCM_UIKIT_NEXT_Desktop_containerShoppingCart_yac55_17","containerMemberLink":"SGCM_UIKIT_NEXT_Desktop_containerMemberLink_yac55_40","iconHeader":"SGCM_UIKIT_NEXT_Desktop_iconHeader_yac55_44","listHeaderLink":"SGCM_UIKIT_NEXT_Desktop_listHeaderLink_yac55_48","menuHeaderLink":"SGCM_UIKIT_NEXT_Desktop_menuHeaderLink_yac55_59","containerHeaderMultipleLink":"SGCM_UIKIT_NEXT_Desktop_containerHeaderMultipleLink_yac55_70","linkHeader":"SGCM_UIKIT_NEXT_Desktop_linkHeader_yac55_77","isActive":"SGCM_UIKIT_NEXT_Desktop_isActive_yac55_85","textHeaderMenuItem":"SGCM_UIKIT_NEXT_Desktop_textHeaderMenuItem_yac55_89"};
styleInject(css_248z);

const isLinkKey = (value) => (typeof value === 'string' && [
    LINK_KEY_NEW_CARS,
    LINK_KEY_USED_CARS,
    LINK_KEY_ELECTRIC_CARS,
    LINK_KEY_HYBRID_CARS,
    LINK_KEY_CAR_LOAN,
    LINK_KEY_RENTAL_CARS,
    LINK_KEY_SELL_CARS,
    LINK_KEY_DIRECTORY,
    LINK_KEY_E_SHOP,
    LINK_KEY_INSURANCE,
    LINK_KEY_ARTICLES,
    LINK_KEY_MORE,
].includes(value));

const PageHeader = ({ activeLink, baseUrlMap, linkDisableMap, shoppingCartCounterValue, user, }) => (jsxs("div", { className: styles.containerRoot, children: [jsx("div", { className: styles.containerSgcmLogo, children: jsx(SgcmLogo, { baseUrlMap: baseUrlMap, variant: "desktop" }) }), jsx("div", { className: styles.containerSearchBar, children: jsx(SearchInput, {}) }), jsx("a", { "aria-label": "Shopping cart", className: cx(styles.containerShoppingCart, styles.iconHeader), href: "/shop/checkout", rel: "noreferrer noopener", children: jsx(NotificationCounter, { className: styles.containerShoppingCartIcon, counterContainerClassName: styles.containerShoppingCartCount, value: shoppingCartCounterValue, children: jsx(Cart, { size: HEADER_SHOPPING_CART_ICON_SIZE }) }) }), jsx("div", { className: styles.containerMemberLink, children: jsx(MemberLink, { user: user, variant: MEMBER_LINK_VARIANT_DESKTOP }) }), jsx("ul", { className: styles.listHeaderLink, children: headerLinkConfigList.filter(({ key }) => (isLinkKey(key) && !linkDisableMap?.[key]))
                .map((headerLink) => {
                const { key, type, text, href, } = headerLink;
                let item = null;
                switch (type) {
                    case HEADER_LINK_TYPE_SINGLE:
                        item = (jsx("a", { className: cx(styles.linkHeader, {
                                [styles.isActive]: activeLink === key,
                            }), href: href, rel: "noreferrer noopener", children: text }));
                        break;
                    case HEADER_LINK_TYPE_MULTIPLE: {
                        const { menuItemList } = headerLink;
                        item = (jsxs("div", { className: styles.containerHeaderMultipleLink, children: [jsx("a", { className: cx(styles.linkHeader, {
                                        [styles.isActive]: activeLink === key,
                                    }), href: href, rel: "noreferrer noopener", children: text }), jsx(Menu, { className: styles.menuHeaderLink, children: menuItemList.map(({ key: menuItemKey, href: menuItemHref, text: menuItemText, }) => (jsx(MenuItem, { children: jsx("a", { className: styles.textHeaderMenuItem, href: menuItemHref, rel: "noreferrer noopener", target: "_self", children: menuItemText }) }, menuItemKey))) })] }));
                        break;
                    }
                }
                return item && (jsx("li", { children: item }, key));
            }) })] }));

export { HEADER_LINK_TYPE_MULTIPLE as H, LINK_KEY_ARTICLES as L, PageHeader as P, HEADER_LINK_TYPE_SINGLE as a, LINK_KEY_CAR_LOAN as b, LINK_KEY_DIRECTORY as c, LINK_KEY_E_SHOP as d, LINK_KEY_ELECTRIC_CARS as e, LINK_KEY_FORUM as f, LINK_KEY_HYBRID_CARS as g, LINK_KEY_INSURANCE as h, LINK_KEY_NEW_CARS as i, LINK_KEY_RENTAL_CARS as j, LINK_KEY_RESOURCES as k, LINK_KEY_SELL_CARS as l, LINK_KEY_USED_CARS as m };
//# sourceMappingURL=component-Dhbam8mv.js.map
